<template>
  <div>
    <skeleton-body :skeleton="skeletonBody" />
    <div class="row" v-if="!skeletonBody">
      <div class="col-12">
        <card>
          <div class="row content-add-btn">
            <div class="col-5" v-if="isCreate()">
              <div class="text-left">
                <button
                  class="btn btn-secondary custom-shadow-btn"
                  @click="$router.push('/advanced/audits/admin/create')"
                >
                  <em class="fa fa-plus"></em>
                  {{ $t('ad_audit.advanced_audit_add') }}
                </button>
              </div>
            </div>
            <div class="col-12 text-center">
              <hr />
            </div>
            <el-dialog
              top="2%"
              v-if="isShow()"
              :title="nameSelected"
              :visible.sync="modals.read"
              width="80%"
            >
              <p>
                {{ $t('common_words.selected_record_info') }}
              </p>
              <div class="card" v-if="rowData">
                <div class="card-body table-responsive" v-if="rowData">
                  <table aria-describedby="tabla-calidad" class="table">
                    <tbody>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.name') }}:</strong>
                          </h6>
                          {{ rowData.name }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{
                              $t('common_words.description')
                            }}</strong>
                          </h6>
                          <template v-if="rowData.description">
                            {{ rowData.description }}
                          </template>
                          <el-tag class="mt-2" v-else type="warning">{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{ $t('common_words.type_grade') }}:</strong
                            >
                          </h6>
                          {{ rowData.type }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{ $t('common_words.type_capture') }}:</strong
                            >
                          </h6>
                          {{ rowData.audit_type_label }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('ad_audit.where_used') }}:</strong>
                          </h6>
                          {{ rowData.where_to_use }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{ $t('common_words.record_quantity') }}:</strong
                            >
                          </h6>
                          {{ rowData.total_records }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{ $t('common_words.records_name') }}:</strong
                            >
                          </h6>
                          <template v-if="rowData.record_name">
                            {{ rowData.record_name }}
                          </template>
                          <el-tag class="mt-2" v-else type="warning">{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{
                                $t('common_words.general_percentage_by_task')
                              }}:</strong
                            >
                          </h6>
                          <template v-if="rowData.discount_percentage !== null">
                            {{ rowData.discount_percentage }}
                          </template>
                          <el-tag class="mt-2" v-else type="warning">{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{
                                $t('common_words.require_signature')
                              }}:</strong
                            >
                          </h6>
                          <p>
                            {{
                              rowData.signature
                                ? $t('common_words.yes')
                                : $t('common_words.no')
                            }}
                          </p>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{
                              $t('common_words.associated_companies')
                            }}</strong>
                          </h6>
                          <span
                            v-for="(
                              business, index
                            ) in rowData.businesses_names"
                            :key="index"
                          >
                            <el-tag type="info">{{ business }}</el-tag>
                          </span>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{
                              $t('common_words.associated_profiles2')
                            }}</strong>
                          </h6>
                          <template v-if="rowData.roles_name.length > 0">
                            <span
                              v-for="(role, index) in rowData.roles_name"
                              :key="index"
                            >
                              <el-tag type="info">{{ role }}</el-tag>
                            </span>
                          </template>
                          <el-tag v-else type="warning">{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong>{{
                              $t('common_words.associated_users2')
                            }}</strong>
                          </h6>
                          <template v-if="rowData.users_name.length > 0">
                            <span
                              v-for="(user, index) in rowData.users_name"
                              :key="index"
                            >
                              <el-tag type="info">{{ user }}</el-tag>
                            </span>
                          </template>
                          <el-tag v-else type="warning">{{
                            $t('common_words.no_assigned')
                          }}</el-tag>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table mb-4">
                            <strong
                              >{{
                                $t('common_words.sub_associated_category')
                              }}:</strong
                            >
                          </h6>
                          <div
                            v-if="rowData.sub_categories.length > 0"
                            class="row table"
                          >
                            <table
                              aria-describedby="tabla-calidad"
                              class="table"
                            >
                              <thead>
                                <tr>
                                  <td></td>
                                  <td>{{ $t('common_words.mayus_tasks') }}</td>
                                  <td>{{ $t('common_words.mayus_type') }}</td>
                                  <td>
                                    {{
                                      $t('common_words.mayus_associated_value')
                                    }}
                                  </td>
                                  <td>
                                    {{ $t('common_words.product_percentage') }}
                                  </td>
                                  <td>
                                    {{ $t('common_words.value_percentage') }}
                                  </td>
                                  <td>
                                    {{ $t('common_words.photo_questionmark') }}
                                  </td>
                                  <td>
                                    {{
                                      $t('common_words.required_questionmark')
                                    }}
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(
                                    subcat, index
                                  ) in rowData.sub_categories"
                                  :key="index"
                                >
                                  <td>
                                    <el-tag style="height: auto" type="info">
                                      <span
                                        v-tooltip.top-center="
                                          subcat.name.length > 15
                                            ? `${subcat.order} - ${subcat.name}`
                                            : ``
                                        "
                                      >
                                        {{ $t('common_words.order') }}:
                                        {{ subcat.order }}<br />
                                        {{ $t('common_words.name') }}:
                                        {{ subcat.name.substring(0, 15)
                                        }}{{
                                          subcat.name.length > 15 ? `...` : ``
                                        }}<br />
                                        {{ $t('common_words.general') }}:
                                        {{
                                          subcat.general
                                            ? $t('common_words.yes')
                                            : $t('common_words.no')
                                        }}<br />
                                        {{ $t('common_words.percentage') }}:
                                        {{
                                          getFormatNumber(
                                            subcat.value_percentage
                                          )
                                        }}%
                                      </span>
                                    </el-tag>
                                  </td>
                                  <td>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-for="(task, j) in subcat.audit_tasks"
                                      :key="j"
                                    >
                                      <span
                                        v-tooltip.top-center="
                                          task.name.length > 32
                                            ? `${task.order} - ${task.name}`
                                            : ``
                                        "
                                      >
                                        {{ task.order }} -
                                        {{ task.name.substring(0, 32)
                                        }}{{
                                          task.name.length > 32 ? `...` : ``
                                        }}
                                      </span>
                                    </p>
                                  </td>
                                  <td>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-for="(task, j) in subcat.audit_tasks"
                                      :key="j"
                                    >
                                      {{ task.calification_type }}
                                    </p>
                                  </td>
                                  <td>
                                    <template
                                      v-for="(task, j) in subcat.audit_tasks"
                                    >
                                      <p
                                        class="d-flex align-items-center size-cell"
                                        :key="j"
                                        v-if="
                                          [
                                            'Fuente de Datos',
                                            'Fuente de Datos Múltiple',
                                          ].includes(task.calification_type)
                                        "
                                      >
                                        {{
                                          task.audit_option_tasks[0]
                                            .data_source_label
                                        }}
                                      </p>
                                      <p
                                        v-tooltip.top-center="
                                          showDialogOptionTask(
                                            task.audit_option_tasks
                                          ).length > 50
                                            ? showDialogOptionTask(
                                                task.audit_option_tasks
                                              )
                                            : ``
                                        "
                                        class="d-flex align-items-center size-cell"
                                        v-else-if="
                                          ['Única', 'Múltiple'].includes(
                                            task.calification_type
                                          )
                                        "
                                      >
                                        {{
                                          showDialogOptionTask(
                                            task.audit_option_tasks
                                          ).substring(0, 50)
                                        }}
                                        {{
                                          showDialogOptionTask(
                                            task.audit_option_tasks
                                          ).length > 50
                                            ? `...`
                                            : ``
                                        }}
                                      </p>
                                      <p
                                        class="d-flex align-items-center size-cell"
                                        v-else-if="
                                          ['Numérica', 'Texto'].includes(
                                            task.calification_type
                                          )
                                        "
                                      >
                                        <label
                                          class="font-weight-light"
                                          style="font-size: 14px"
                                        >
                                          {{
                                            'Min: ' +
                                            roundNumber(task.minimum, 2) +
                                            ' - Max: ' +
                                            roundNumber(task.maximum, 2)
                                          }}
                                        </label>
                                      </p>
                                      <p
                                        class="d-flex align-items-center size-cell"
                                        v-else-if="
                                          task.calification_type == 'Subjetiva'
                                        "
                                      >
                                        <label class="row subject-calification">
                                          <div class="px-0 mr-1">
                                            <el-tag
                                              type="info"
                                              style="width: 30px"
                                            >
                                              0
                                            </el-tag>
                                          </div>
                                          ...
                                          <div class="px-0 mr-1">
                                            <el-tag
                                              type="info"
                                              style="width: 30px"
                                            >
                                              10
                                            </el-tag>
                                          </div>
                                          ...
                                          <div class="px-0 mr-1">
                                            <el-tag
                                              type="info"
                                              style="width: 38px"
                                            >
                                              NA
                                            </el-tag>
                                          </div>
                                          <div class="px-0 mr-1">
                                            <el-tooltip placement="top">
                                              <div slot="content">
                                                <p>
                                                  <strong>
                                                    {{
                                                      $t(
                                                        'audit.compliance_type'
                                                      )
                                                    }}
                                                    :
                                                  </strong>
                                                  {{
                                                    task.type_discount ==
                                                    'Variado'
                                                      ? $t('audit.variable')
                                                      : $t('audit.fixed')
                                                  }}
                                                </p>
                                                <div
                                                  v-if="
                                                    task.type_discount ==
                                                    'Variado'
                                                  "
                                                >
                                                  <p
                                                    v-for="(
                                                      compliance, index
                                                    ) in task.advanced_audit_task_discounts"
                                                    :key="index"
                                                  >
                                                    <strong>
                                                      {{
                                                        $t('common_words.range')
                                                      }}
                                                      :
                                                    </strong>
                                                    {{ compliance.range }} -
                                                    <strong>
                                                      {{
                                                        $t('common_words.value')
                                                      }}
                                                      :
                                                    </strong>

                                                    {{
                                                      getFormatNumber(
                                                        compliance.discount
                                                      )
                                                    }}%
                                                  </p>
                                                </div>
                                              </div>
                                              <a>
                                                <em class="fa fa-eye"> </em>
                                              </a>
                                            </el-tooltip>
                                          </div>
                                        </label>
                                      </p>
                                      <p
                                        class="d-flex align-items-center size-cell"
                                        v-else-if="
                                          task.calification_type ==
                                          'Subjetiva 2'
                                        "
                                      >
                                        <label class="row subject-calification">
                                          <div class="px-0 mr-1">
                                            <el-tag
                                              type="info"
                                              style="width: 30px"
                                            >
                                              0
                                            </el-tag>
                                          </div>
                                          ...
                                          <div class="px-0 mr-1">
                                            <el-tag
                                              type="info"
                                              style="width: 30px"
                                            >
                                              5
                                            </el-tag>
                                          </div>
                                          ...
                                          <div class="px-0 mr-1">
                                            <el-tag
                                              type="info"
                                              style="width: 38px"
                                            >
                                              NA
                                            </el-tag>
                                          </div>
                                          <div class="px-0 mr-1">
                                            <el-tooltip placement="top">
                                              <div slot="content">
                                                <p>
                                                  <strong>
                                                    {{
                                                      $t(
                                                        'audit.compliance_type'
                                                      )
                                                    }}
                                                    :
                                                  </strong>
                                                  {{
                                                    task.type_discount ==
                                                    'Variado'
                                                      ? $t('audit.variable')
                                                      : $t('audit.fixed')
                                                  }}
                                                </p>
                                                <div
                                                  v-if="
                                                    task.type_discount ==
                                                    'Variado'
                                                  "
                                                >
                                                  <p
                                                    v-for="(
                                                      compliance, index
                                                    ) in task.advanced_audit_task_discounts"
                                                    :key="index"
                                                  >
                                                    <strong>
                                                      {{
                                                        $t('common_words.range')
                                                      }}
                                                      :
                                                    </strong>
                                                    {{ compliance.range }}.
                                                    <strong>
                                                      {{
                                                        $t('common_words.value')
                                                      }}
                                                      :
                                                    </strong>

                                                    {{
                                                      getFormatNumber(
                                                        compliance.discount
                                                      )
                                                    }}%.
                                                  </p>
                                                </div>
                                              </div>
                                              <a>
                                                <em class="fa fa-eye"> </em>
                                              </a>
                                            </el-tooltip>
                                          </div>
                                        </label>
                                      </p>
                                      <p
                                        class="d-flex align-items-center size-cell"
                                        v-else
                                      >
                                        {{ $t('common_words.does_not_apply') }}
                                      </p>
                                    </template>
                                  </td>
                                  <td>
                                    <template
                                      v-for="(task, j) in subcat.audit_tasks"
                                    >
                                      <p
                                        v-if="true"
                                        class="d-flex align-items-center size-cell"
                                        :key="j"
                                      >
                                        {{
                                          task.discount_percentage
                                            ? `${getFormatNumber(
                                                task.discount_percentage
                                              )}%`
                                            : '--'
                                        }}
                                      </p>
                                    </template>
                                  </td>
                                  <td>
                                    <template
                                      v-for="(task, j) in subcat.audit_tasks"
                                    >
                                      <p
                                        v-if="true"
                                        class="d-flex align-items-center size-cell"
                                        :key="j"
                                      >
                                        {{
                                          task.value_percentage
                                            ? `${getFormatNumber(
                                                task.value_percentage
                                              )}%`
                                            : '--'
                                        }}
                                      </p>
                                    </template>
                                  </td>
                                  <td>
                                    <template
                                      v-for="(task, j) in subcat.audit_tasks"
                                    >
                                      <p
                                        v-if="task.photo_required !== undefined"
                                        class="d-flex align-items-center size-cell"
                                        :key="j"
                                      >
                                        {{
                                          task.photo_required === 1
                                            ? 'Si'
                                            : 'No'
                                        }}
                                      </p>
                                      <p v-else>{{ $t('common_words.no') }}</p>
                                    </template>
                                  </td>
                                  <td>
                                    <template
                                      v-for="(task, j) in subcat.audit_tasks"
                                    >
                                      <p
                                        v-if="task.is_required !== undefined"
                                        class="d-flex align-items-center size-cell"
                                        :key="j"
                                      >
                                        {{
                                          task.is_required === 1
                                            ? $t('common_words.yes')
                                            : $t('common_words.no')
                                        }}
                                      </p>
                                      <p v-else>{{ $t('common_words.no') }}</p>
                                    </template>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <el-tag
                            type="warning"
                            v-if="rowData.sub_categories.length == 0"
                            >{{
                              $t('common_words.no_sub_associated_category')
                            }}</el-tag
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer footer-date-at" v-if="rowData">
                  <p class="text-muted">
                    <small
                      >{{ $t('common_words.created_on') }}:
                      {{ rowData.created_at }}</small
                    >
                  </p>
                </div>
              </div>
            </el-dialog>
          </div>
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                filterable
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                :data="queriedData"
                max-height="500"
                style="width: 100%"
                :border="true"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  :fixed="column.fixed"
                  :sortable="column.sortable"
                  :align="column.align"
                  :resizable="false"
                ></el-table-column>
                <el-table-column
                  :label="$t('common_words.companies')"
                  min-width="120"
                  prop="businesses_names"
                  :sortable="true"
                  :resizable="false"
                  :align="`center`"
                >
                  <template slot-scope="scope">
                    <el-badge
                      class="custom-el-badge__content item"
                      v-if="scope.row.businesses_names.length > 0"
                      :hidden="
                        scope.row.businesses_names.length == 1 ? true : false
                      "
                      :value="200"
                      :max="scope.row.businesses_names.length - 1"
                    >
                      <el-button plain type="info" size="small">
                        {{ scope.row.businesses_names[0] }}</el-button
                      >
                    </el-badge>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('common_words.sub_category')"
                  min-width="120"
                  prop="sub_categories[0].name"
                  :sortable="true"
                  :resizable="false"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-badge
                      class="custom-el-badge__content item"
                      v-if="scope.row.sub_categories.length > 0"
                      :hidden="
                        scope.row.sub_categories.length == 1 ? true : false
                      "
                      :value="200"
                      :max="scope.row.sub_categories.length - 1"
                    >
                      <el-button plain type="info" size="small">
                        {{ scope.row.sub_categories[0].name }}</el-button
                      >
                    </el-badge>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="isShow() || isUpdate() || isDelete()"
                  :min-width="90"
                  :label="$t('common_words.operations')"
                  fixed="right"
                  :resizable="false"
                >
                  <template slot-scope="props">
                    <div class="text-center">
                      <a
                        v-if="isShow()"
                        v-tooltip.top-center="$t('common_words.view')"
                        class="btn-info btn-simple btn-link custom-margin-actions"
                        @click="handleView(props.$index, props.row)"
                      >
                        <em class="fa fa-eye custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.edit')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click="handleEdit(props.$index, props.row)"
                      >
                        <em class="fa fa-edit custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDelete(props.$index, props.row)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>
        </card>
      </div>
    </div>
    <div
      class="row"
      v-if="!skeletonBody"
      style="padding-right: 13px; padding-left: 13px"
    >
      <div class="col-6" v-if="isPDF()">
        <div class="text-right">
          <button class="btn btn-danger custom-shadow-btn" @click="exportToPDF">
            <em class="fa fa-file-pdf-o"></em>
            {{ $t('common_words.export_to_pdf') }}
          </button>
        </div>
      </div>
      <div class="col-6" v-if="isExcel()">
        <div class="text-left">
          <button
            class="btn custom-btn-success custom-shadow-btn"
            @click="exportToExcel"
          >
            <em class="fa fa-file-excel-o"></em>
            {{ $t('common_words.export_to_excel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import { Slider } from 'element-ui';
import configTable from './advanced-audit-table';
import Formatter from 'src/class/Formatter';
import Fuse from 'fuse.js';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinNumbers from 'src/util/mixinNumbers';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinSkeleton from 'src/util/mixinSkeleton';
import moment from 'moment';
import SkeletonBody from 'src/components/SkeletonBody.vue';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
    [Slider.name]: Slider,
    [SkeletonBody.name]: SkeletonBody,
  },

  data() {
    return {
      Table: {},
      Search: {},
      advancedAuditForm: {},
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
    };
  },

  computed: {
    ...configTable().Search,

    nameSelected() {
      return this.$i18n.t('common_words.record_selected_threepoints');
    },
  },

  mixins: [
    MixinPermissions,
    MixinMasters,
    MixinExport,
    MixinNumbers,
    MixinSkeleton,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    getFormatNumber(value) {
      return Formatter.formatNumber(Number(value), 3);
    },

    showDialogOptionTask(data) {
      const items = data.map(function (item) {
        return item.name;
      });

      return `["${items.join('", "')}"]`;
    },

    handleView(_, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(_, row) {
      row.url_path_form = '/advanced/audits/admin/edit';
      this.advancedAuditForm = Object.assign({}, row);
      sessionStorage.setItem(
        'editForm',
        JSON.stringify(this.advancedAuditForm)
      );
      this.$router.push({
        path: '/advanced/audits/admin/edit',
      });
    },

    handleDelete(_, row) {
      this.advancedAuditForm = Object.assign({}, row);
      SweetAlert.delete(this.advancedAuditForm.name).then((result) => {
        if (result.value) this.deleteAdvancedAudit();
      });
    },

    deleteAdvancedAudit() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.advancedAuditForm.route = 'advanced/audits/admin';
        Axios.destroyMaster(this.advancedAuditForm)
          .then((response) => {
            this.modifyTable(2, this.advancedAuditForm.id, response);
            this.showHideLoading();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'advanced/audits/admin/pdf';
      (data.name_file = `${i18n.t('ad_audit.advanced_audit')}.pdf`),
        this.PDF(data)
          .then(() => {
            this.showDownloadNotification();
          })
          .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = 'advanced/audits/admin/excel';
      data.name_file = `${i18n.t('ad_audit.advanced_audit')}.xlsx`;
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    setupTable() {
      const { Table, Search } = configTable();

      this.Table = Table;
      this.Search = Search;
      this.pagination = Table.pagination;
      this.tableColumns = Table.tableColumns;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('advanced/audits/admin')
        .then((response) => {
          this.hideSkeletonBody();
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },

  mounted() {
    this.selectedItemOnMenu('advanced');
  },

  destroyed() {
    this.deselectedItemOnMenu('advanced');
  },
};
</script>
<style></style>
